import React from "react";
import styled, { css } from "styled-components";

const InnerWrapper = styled.div(({ theme }) => css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: ${theme.palette.main.fieldWell};
  border-radius: 15px;
  padding: 30px 40px;

  .manage-repayment-pay-higher-button {
    margin: 15px 0 0;
    background-color: ${theme.buttons.secondary.background};
    color: ${theme.buttons.secondary.color};
    font-size: ${theme.buttons.fontSize};
    font-weight: ${theme.buttons.fontWeight};

    @media (hover: hover) {
      &:hover {
        color: ${theme.buttons.secondary.colorHover};
        background-color: ${theme.buttons.secondary.backgroundHover};
      }
    }
  }

  .manage-repayment-submit {
    align-self: flex-end;
  }
`);

const OuterWrapper = styled.div`
  padding: 5px 0 20px;
`;

export const Wrapper = ({ children }) => (
  <OuterWrapper>
    <InnerWrapper>{children}</InnerWrapper>
  </OuterWrapper>
);